import Splide from '@splidejs/splide';
import '@splidejs/splide/css';

const home = (): void => {
  // MVスライダー
  const mvSplide: any = new Splide('.p-home-mv__images', {
    type: 'fade',
    loop: true,
    rewind: true,
    autoplay: true,
    interval: 5000,
    speed: 3000,
    pauseOnHover: false,
    arrows: false,
    pagination: false,
  }).mount();

  // 枚数を取得
  const slideCount: number = mvSplide.length;
  // ページネーションを生成
  const paginateWrapper: HTMLElement | null = document.querySelector('.p-home-mv__paginate-list');
  if (paginateWrapper !== null) {
    for (let i = 0; i < slideCount; i++) {
      const a: HTMLAnchorElement = document.createElement('a');
      const num:string = ('0' + (i + 1)).slice(-2);
      a.setAttribute('href', 'javascript:void(0)');
      if (i === 0) a.classList.add('is-active');
      a.textContent = `${num}`;
      paginateWrapper.appendChild(a);
    }
  }

  // ページネーションの要素を取得
  const paginateItems: NodeListOf<HTMLAnchorElement> = document.querySelectorAll('.p-home-mv__paginate-list > a');

  // スライダーが変化した時のイベント
  mvSplide.on('moved', () => {
    // アクティブなスライドのインデックスを取得
    const activeIndex: number = mvSplide.index;
    // ページネーションのアクティブを切り替え
    paginateItems.forEach((item: HTMLAnchorElement, index: number) => {
      if (index === activeIndex) {
        item.classList.add('is-active');
      } else {
        item.classList.remove('is-active');
      }
    });
  });

  // ページネーションをクリックした時のイベント
  paginateItems.forEach((item: HTMLAnchorElement, index: number) => {
    item.addEventListener('click', () => {
      mvSplide.go(index);
    });
  });
};

export default home;
